import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { makeStyles, RaiseColors, useTheme, useMediaQuery } from "componentLibrary";
import RaiseButton, { ButtonVariantEnum, ButtonSizeEnum } from "componentLibrary/MuiComponentWrappers/Button/RaiseButton";
import React from "react";
import * as Yup from "yup";
import LoginFormContentContainer from "./LoginFormContentContainer";
import Cookies from "js-cookie";
import { WorkplaceOSLoginContainer, WorkplaceOSLoginHeader, WorkplaceOSLoginTerms } from "./WorkplaceOSLoginCommon";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      container: {
        height: "100%",
        width: "100%",
        display: "flex",
        backgroundColor: RaiseColors.neutral200
      },
      loginContentContainer: _defineProperty({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: RaiseColors.neutral200,
        margin: "auto"
      }, theme.breakpoints.up("md"), {
        width: "60%"
      }),
      loginContentImage: _defineProperty(_defineProperty({
        height: 48,
        width: 268
      }, theme.breakpoints.down("smMd"), {
        width: 178,
        height: 32
      }), "marginBottom", "40px"),
      stockImage: {
        height: "100%",
        width: "40%",
        objectFit: "cover",
        backgroundColor: RaiseColors.midnight
      },
      errorText: {
        color: RaiseColors.warning,
        fontSize: "13px"
      }
    };
  });
};
var WorkplaceSetPassword = function WorkplaceSetPassword(_ref) {
  var params = _ref.params;
  var classes = useStyles()();
  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.down("md"));
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    passwordSetSuccessful = _React$useState2[0],
    setPasswordSetSuccessful = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    loading = _React$useState4[0],
    setLoading = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isError = _React$useState6[0],
    setIsError = _React$useState6[1];
  var _React$useState7 = React.useState("Password Length must be at least 8 characters."),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    errorMessage = _React$useState8[0],
    setErrorMessage = _React$useState8[1];
  var _React$useState9 = React.useState(null),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    snackBarMessage = _React$useState0[0],
    setSnackBarMessage = _React$useState0[1];
  var _React$useState1 = React.useState(""),
    _React$useState10 = _slicedToArray(_React$useState1, 2),
    currentState = _React$useState10[0],
    setCurrentState = _React$useState10[1];
  var _React$useState11 = React.useState("default"),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    message = _React$useState12[0],
    setMessage = _React$useState12[1];
  var ValidationSchema = Yup.object().shape({
    newPassword: Yup.string().nullable().min(8, "Password Length must be at least 8 characters."),
    reenterNewPassword: Yup.string().nullable().oneOf([Yup.ref("newPassword")], "Passwords did not match, please try again.")
  });
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var newPassword, confirmPassword, userEmail, postData, response, data, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            newPassword = _ref2.newPassword, confirmPassword = _ref2.confirmPassword, userEmail = _ref2.userEmail;
            if (!(newPassword !== confirmPassword)) {
              _context.next = 1;
              break;
            }
            setIsError(true);
            setErrorMessage("Passwords did not match, please try again.");
            _context.next = 6;
            break;
          case 1:
            postData = {
              new_password: newPassword,
              confirm_password: confirmPassword,
              activation_code: params.activation_code,
              user_id: params.user_id,
              email: userEmail
            };
            setLoading(true);
            _context.prev = 2;
            _context.next = 3;
            return fetch("/ajax/accounts/activate_account", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": Cookies.get("csrftoken") || ""
              },
              body: _JSON$stringify(postData)
            });
          case 3:
            response = _context.sent;
            _context.next = 4;
            return response.json();
          case 4:
            data = _context.sent;
            if (response.ok && data.successful) {
              window.location.assign("/".concat(params.org_id));
              setLoading(false);
            } else {
              setMessage(data.message);
              setCurrentState(data.currentState);
              setIsError(true);
              setErrorMessage("An unexpected error has occurred.");
              setLoading(false);
            }
            _context.next = 6;
            break;
          case 5:
            _context.prev = 5;
            _t = _context["catch"](2);
            setSnackBarMessage(/*#__PURE__*/_jsx("div", {
              className: classes.errorText,
              children: "An unexpected error has occurred"
            }));
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 5]]);
    }));
    return function handleSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var formElements = [{
    id: "newPassword",
    initialValue: "",
    label: "New password",
    placeholder: "8 characters minimum",
    type: "password"
  }, {
    id: "confirmPassword",
    initialValue: "",
    label: "Reenter new password",
    placeholder: "8 characters minimum",
    type: "password"
  }];
  var SetPasswordSuccessView = function SetPasswordSuccessView() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(WorkplaceOSLoginContainer, {
        children: [/*#__PURE__*/_jsx(WorkplaceOSLoginHeader, {
          title: "Set Password",
          subHeader: "Your password has been successfully set!"
        }), /*#__PURE__*/_jsx(RaiseButton, {
          variant: ButtonVariantEnum.primary,
          size: isMobile ? ButtonSizeEnum.medium : ButtonSizeEnum.large,
          onClick: function onClick() {
            window.location.href = "/raise_login/:next";
          },
          setToFill: true,
          children: "Return to sign in"
        })]
      }), /*#__PURE__*/_jsx(WorkplaceOSLoginTerms, {})]
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: classes.container,
      children: [/*#__PURE__*/_jsxs("div", {
        className: classes.loginContentContainer,
        children: [/*#__PURE__*/_jsx("img", {
          src: "".concat(window.STATIC_URL, "images/logos/JLL/JLL Leasing OS Logo.svg"),
          className: classes.loginContentImage
        }), passwordSetSuccessful ? /*#__PURE__*/_jsx(SetPasswordSuccessView, {}) : /*#__PURE__*/_jsx(LoginFormContentContainer, {
          header: "Set password",
          formElements: formElements,
          ValidationSchema: ValidationSchema,
          handleSubmit: handleSubmit,
          loading: loading,
          isError: isError,
          errorMessage: errorMessage,
          buttonText: "Enter Platform"
        })]
      }), !isMobile ? /*#__PURE__*/_jsx("img", {
        className: classes.stockImage,
        src: "".concat(window.STATIC_URL, "images/JLL Login Workspace Cover.jpg")
      }) : null]
    })
  });
};
export default WorkplaceSetPassword;